<template>
    <div class="container-fluid justify-content-center">

        <div class="row">
            <div class="col-md-6">
                <team-members></team-members>
            </div>
            <div class="col-md-6">
                <team-settings></team-settings>
            </div>
        </div>




    </div>
</template>

<script>
    import NotificationPop from '../mixins/NotificationPop.js'
    import Channels from "../components/Channels";
    import UpgradeNotification
        from "../mixins/UpgradeNotification";
    import TeamSettings
        from "../components/TeamSettings";
    import TeamMembers
        from "../components/TeamMembers";

    export default {
        mixins: [NotificationPop, UpgradeNotification],
        components: { TeamSettings, TeamMembers },
        data: () => ({

        }),
        async created() {

        }
    }
</script>
